import { t } from "i18next";
import Modal from "react-bootstrap/Modal";
import PrimaryButton from "../../components/Common/PrimaryButton/PrimaryButton";
import images from "../../resources/images";
import classes from "./ExternalReviewModal.module.css";

const ExternalReviewModal = ({ show, onHide, entityType, entityId, onNavigateToReview }) => {
  const handleSubmitReview = () => {
    onHide();
    if (onNavigateToReview) {
      onNavigateToReview();
    }
  };

  return (
    <Modal show={show} contentClassName={classes.mainContainer} onHide={onHide} size="lg" centered>
      <div className={classes.contentContainer}>
        <img className={classes.foxImage} src={images.aiFox} alt="AI Fox" />

        <div className={classes.textContainer}>
          <h2 className={classes.title}>{t("externalReviewModal_title")}</h2>
          <p className={classes.subtitle}>{t("externalReviewModal_subtitle")}</p>
          <p className={classes.subtitle}>{t("externalReviewModal_subtitle_2")}</p>
          <p className={classes.help}>{t("externalReviewModal_help")}</p>
        </div>

        <div className={classes.buttonsContainer}>
          <PrimaryButton
            className={classes.uploadButton}
            title={t("externalReviewModal_upload")}
            onClick={handleSubmitReview}
            isBig={true}
          />

          <button className={classes.closeButton} onClick={onHide}>
            {t("close")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ExternalReviewModal;
